<template>
  	<div id="footer" class="bg-dark">
		<h4 class="text-muted text-center">&copy kyleweb.dev</h4>
		<br>
	</div>
</template>

<script>
export default {
  name: 'FooterEnd',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>
